import LandingPage from "@/LandingPage.vue";
import LoginForm from "@/LoginForm.vue";
import MFAForm from "@/MFAForm.vue";
import SSOPage from "@/SSOPage.vue";
import HotelDetail from "@/HotelDetail.vue";
import HotelReservationForm from "@/HotelReservationForm.vue";
import MeetingRoomReservation from "@/MeetingRoomReservation.vue";
import ReservationOverview from "@/ReservationOverview.vue";
import SearchResult from "@/SearchResult.vue";
import UserProfile from "@/UserProfile.vue";
import FlightForm from "@/FlightForm.vue";
import CommonHelper from "@/helpers/common.helper";
import ReservationConfirmation from "@/ReservationConfirmation.vue";
import TransportConfirmation from "@/TransportConfirmation.vue";
import MeetingRoomConfirmation from "@/MeetingRoomConfirmation.vue";
import TrainConfirmation from "@/TrainConfirmation.vue";
import TrainForm from "@/TrainForm.vue";
import CarForm from "@/CarForm.vue";
import CarConfirmation from "@/CarConfirmation.vue";
import PartialErrorPage from "@/PartialErrorPage.vue";
import BookingRulesPage from "@/BookingRulesPage.vue";
import OpenRequestReservation from "@/OpenRequestReservation.vue";
import OpenRequestConfirmation from "@/OpenRequestConfirmation.vue";
const PAGES = CommonHelper.PAGES;

const checkRoute = (to, from, next) => {
  const isLoggedIn = CommonHelper.isLoggedIn();
  const hasToken = CommonHelper.hasToken();

  if (
    to.name !== PAGES.Login &&
    to.name !== PAGES.SSO &&
    !isLoggedIn &&
    !hasToken
  ) {
    //console.log("rd 1 (page requested, not logged in)");
    sessionStorage.setItem("redirectAfterLogin", to.fullPath);
    next({ name: PAGES.Login });
  } else if (to.name == PAGES.Login && !isLoggedIn && hasToken) {
    //console.log("rd 2 (Login request, has token)");
    next({ name: PAGES.MFA });
  } else if (to.name == PAGES.Login && isLoggedIn) {
    //console.log("rd 3 (login requested, is logged in)");
    next({ name: PAGES.LandingPage });
  } else {
    //console.log("rd 4 (pass)");
    // This is for the search page, which is not tracked when the feedbackid is added
    const isSamePageRedirect = from?.name === to?.name;
    let isIngorableSearchPage = to.params?.feedbackId && isSamePageRedirect;

    if (!isIngorableSearchPage) {
      trackEvent({
        event: "pageview",
        pageTitle: to.name,
        pageUrl: to.path,
        locale: localStorage.getItem("locale") || "nl"
      });
    }
    next();
  }
};

const trackEvent = (config) => {
  window.dataLayer.push(config);
};
const routes = [
  { path: "/", component: LoginForm, name: PAGES.Login },
  {
    path: "/sso/:companyOrSessionId/:SessionSecondsValid?",
    component: SSOPage,
    name: PAGES.SSO
  },

  { path: "/mfa", component: MFAForm, name: PAGES.MFA },
  { path: "/userprofile", component: UserProfile, name: PAGES.UserProfile },
  { path: "/flightform", component: FlightForm, name: PAGES.FlightForm },
  { path: "/trainform", component: TrainForm, name: PAGES.TrainForm },
  { path: "/carform", component: CarForm, name: PAGES.CarForm },
  { path: "/home", component: LandingPage, name: PAGES.LandingPage },
  {
    path: "/search/:locationPath/:checkin/:nights/:adults/:rooms/:refundable/:greenKey?/:feedbackId?",
    component: SearchResult,
    name: PAGES.SearchResult
  },
  {
    path: "/hotel/:locationPath/:hotelId/:checkin?/:nights?/:adults?/:rooms?/:refundable?/:greenKey?/:feedbackId?/:breakfastIncluded?",
    component: HotelDetail,
    name: PAGES.HotelDetail,
    props: true
  },
  {
    path: "/reservation/:locationPath/:hotelId/:checkin/:nights/:adults/:rooms/:refundable/:greenKey?/:feedbackId?/:breakfastIncluded?",
    props: (route) => ({
      reservationType: "hotel",
      ...route.params
    }),
    name: PAGES.HotelReservationForm,
    component: HotelReservationForm
  },
  {
    path: "/reservation/:locationPath/:hotelId/:checkin?/:nights?/:adults?/:guests?/:rooms?/:preselectedBusinessUnitId?/:breakfastIncluded?",
    props: (route) => ({
      reservationType: "hotel",
      ...route.params
    }),
    name: PAGES.HotelRebook,
    component: HotelReservationForm
  },
  {
    path: "/cityreservation/:city/:checkin/:nights/:adults/:rooms/:latitude?/:longitude?/:breakfastIncluded?",
    props: (route) => ({
      reservationType: "city",
      ...route.params
    }),
    name: PAGES.CityReservationForm,
    component: HotelReservationForm
  },
  {
    path: "/meetingroomreservation",
    props: (route) => ({
      ...route.params
    }),
    name: PAGES.MeetingRoomReservation,
    component: MeetingRoomReservation
  },
  {
    path: "/openRequest",
    name: PAGES.OpenRequest,
    component: OpenRequestReservation
  },
  {
    path: "/openRequest-confirmation",
    name: "OpenRequestConfirmation",
    component: OpenRequestConfirmation
  },
  {
    path: "/reservation-overview",
    props: (route) => ({
      ...route.params
    }),
    name: PAGES.ReservationOverview,
    component: ReservationOverview
  },
  {
    path: "/reservation-confirmation",
    name: "ReservationConfirmation",
    component: ReservationConfirmation
  },
  {
    path: "/flight-confirmation",
    name: "TransportConfirmation",
    component: TransportConfirmation
  },
  {
    path: "/meetingroom-confirmation",
    name: "MeetingRoomConfirmation",
    component: MeetingRoomConfirmation
  },
  {
    path: "/train-confirmation",
    name: "TrainConfirmation",
    component: MeetingRoomConfirmation
  },
  {
    path: "/car-confirmation",
    name: "CarConfirmation",
    component: CarConfirmation
  },
  {
    path: "/partial-error",
    name: PAGES.PartialError,
    component: PartialErrorPage
  },
  {
    path: "/booking-rules",
    name: PAGES.BookingRules,
    component: BookingRulesPage
  }
];

const mainWrapper = document.getElementById("app");
mainWrapper.style.opacity = "0";
const checkSessionValidity = async (router) => {
  let currentUrl = window.location.href;
  if (currentUrl.includes("login") || currentUrl.includes("sso")) {
    console.log("Skipping validation for", currentUrl);
    mainWrapper.style.opacity = "1";
    return;
  }
  const sessionIsValid = await CommonHelper.sessionIsValid();
  mainWrapper.style.opacity = "1";
  if (!sessionIsValid) {
    const currentPath = window.location.pathname + window.location.search;
    if (currentPath !== "/" && !currentPath.includes("/mfa")) {
      sessionStorage.setItem("redirectAfterLogin", currentPath);
    }
    await CommonHelper.invalidateSession();
    router.push({ name: PAGES.Login });
  } else {
    checkCompanyInfoDate();
  }
};
const checkCompanyInfoDate = async () => {
  const ciDate = localStorage.ciDate;
  const todaysHash = CommonHelper.getDateHash();
  if (ciDate !== todaysHash) {
    await CommonHelper.fetchCompanyInfo();
  }
};

export { checkRoute, routes, checkSessionValidity };
